import Vue from 'vue'
import api from '@/api'
import {
  SIDEBAR_TYPE,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR,
  DEFAULT_COLOR_WEAK,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_TAB
} from '@/store/mutation-types'

const app = {
  state: {
    sidebar: true,
    device: 'desktop',
    theme: '',
    layout: '',
    contentWidth: '',
    fixedHeader: false,
    fixSiderbar: false,
    autoHideHeader: false,
    color: null,
    weak: false,
    multiTab: true,
    QiniuImageToken: '',
    QiniuVideoToken: '',
    QiniuQNPToken: '',
    ModalList: '',

    unreadMenuList: [],
    myPlanUnread: false,
  },
  mutations: {
    SET_SIDEBAR_TYPE: (state, type) => {
      state.sidebar = type
      Vue.ls.set(SIDEBAR_TYPE, type)
    },
    CLOSE_SIDEBAR: (state) => {
      Vue.ls.set(SIDEBAR_TYPE, true)
      state.sidebar = false
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_THEME: (state, theme) => {
      Vue.ls.set(DEFAULT_THEME, theme)
      state.theme = theme
    },
    TOGGLE_LAYOUT_MODE: (state, layout) => {
      Vue.ls.set(DEFAULT_LAYOUT_MODE, layout)
      state.layout = layout
    },
    TOGGLE_FIXED_HEADER: (state, fixed) => {
      Vue.ls.set(DEFAULT_FIXED_HEADER, fixed)
      state.fixedHeader = fixed
    },
    TOGGLE_FIXED_SIDERBAR: (state, fixed) => {
      Vue.ls.set(DEFAULT_FIXED_SIDEMENU, fixed)
      state.fixSiderbar = fixed
    },
    TOGGLE_FIXED_HEADER_HIDDEN: (state, show) => {
      Vue.ls.set(DEFAULT_FIXED_HEADER_HIDDEN, show)
      state.autoHideHeader = show
    },
    TOGGLE_CONTENT_WIDTH: (state, type) => {
      Vue.ls.set(DEFAULT_CONTENT_WIDTH_TYPE, type)
      state.contentWidth = type
    },
    TOGGLE_COLOR: (state, color) => {
      Vue.ls.set(DEFAULT_COLOR, color)
      state.color = color
    },
    TOGGLE_WEAK: (state, flag) => {
      Vue.ls.set(DEFAULT_COLOR_WEAK, flag)
      state.weak = flag
    },
    TOGGLE_MULTI_TAB: (state, bool) => {
      Vue.ls.set(DEFAULT_MULTI_TAB, bool)
      state.multiTab = bool
    },
    SET_QINIU_IMAGE_TOKEN: (state, token) => {
      state.QiniuImageToken = token
    },
    SET_QINIU_VIDEO_TOKEN: (state, token) => {
      state.QiniuVideoToken = token
    },
    SET_QINIU_QNP_TOKEN: (state, token) => {
      state.QiniuQNPToken = token
    },
    ADD_MODAL_QUEUE: (state, modal) => {
      let arr = null
      if (state.ModalList === '') {
        arr = []
      } else {
        arr = state.ModalList.split(',')
      }
      arr.push(modal)
      state.ModalList = arr.join(',')
    },
    POP_MODAL_QUEUE (state, modal) {
      const arr = state.ModalList.split(',')

      arr.shift()
      state.ModalList = arr.join(',')
    },
    SET_UNREAD_LIST(state, data) {
      state.unreadMenuList = data
    },
    SET_MY_PLAN_UNREAD(state, bool) {
      state.myPlanUnread = bool
    }
  },
  actions: {
    setSidebar ({ commit }, type) {
      commit('SET_SIDEBAR_TYPE', type)
    },
    CloseSidebar ({ commit }) {
      commit('CLOSE_SIDEBAR')
    },
    ToggleDevice ({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    ToggleTheme ({ commit }, theme) {
      commit('TOGGLE_THEME', theme)
    },
    ToggleLayoutMode ({ commit }, mode) {
      commit('TOGGLE_LAYOUT_MODE', mode)
    },
    ToggleFixedHeader ({ commit }, fixedHeader) {
      if (!fixedHeader) {
        commit('TOGGLE_FIXED_HEADER_HIDDEN', false)
      }
      commit('TOGGLE_FIXED_HEADER', fixedHeader)
    },
    ToggleFixSiderbar ({ commit }, fixSiderbar) {
      commit('TOGGLE_FIXED_SIDERBAR', fixSiderbar)
    },
    ToggleFixedHeaderHidden ({ commit }, show) {
      commit('TOGGLE_FIXED_HEADER_HIDDEN', show)
    },
    ToggleContentWidth ({ commit }, type) {
      commit('TOGGLE_CONTENT_WIDTH', type)
    },
    ToggleColor ({ commit }, color) {
      commit('TOGGLE_COLOR', color)
    },
    ToggleWeak ({ commit }, weakFlag) {
      commit('TOGGLE_WEAK', weakFlag)
    },
    ToggleMultiTab ({ commit }, bool) {
      commit('TOGGLE_MULTI_TAB', bool)
    },
    GetQiniuImageToken ({ commit }, params = { action: 'upload' }) {
      return api.qiniu.getImageToken(params)
        .then(res => {
          commit('SET_QINIU_IMAGE_TOKEN', res.data.auth_token)
          return res
        })
        .catch(() => {})
    },
    GetQiniuVideoToken ({ commit }, params = { action: 'upload' }) {
      return api.qiniu.getVideoToken(params)
        .then(res => {
          commit('SET_QINIU_VIDEO_TOKEN', res.data.auth_token)
          return res
        })
        .catch(() => {})
    },
    GetQNPToken ({ commit }, params = { action: 'upload' }) {
      return api.qiniu.getQNPToken(params)
        .then(res => {
          commit('SET_QINIU_QNP_TOKEN', res.data.auth_token)
          return res
        })
        .catch(() => {})
    },
    ADD_MODAL_QUEUE ({ commit }, params) {
      commit('ADD_MODAL_QUEUE', params)
    },
    POP_MODAL_QUEUE ({ commit }, params) {
      commit('POP_MODAL_QUEUE', params)
    },
    async GetUnreadMenuList({ commit }) {
      const result = []
      // 企划招募未读小红点
      const { data } = await api.planning.getMyPlanTipStatus()
      result.push({ name: 'planning', showDot: data.my_list_status === 1 })
      commit('SET_UNREAD_LIST', result.filter(item => item.showDot).map(item => item.name))
      commit('SET_MY_PLAN_UNREAD', data.my_list_status === 1)
    }
  }
}

export default app
